var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 21 21",
        stroke: "currentColor",
        width: "21",
        height: "21",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M18.3125 0.103027H2.3125C1.2125 0.103027 0.3225 1.00303 0.3225 2.10303L0.3125 20.103L4.3125 16.103H18.3125C19.4125 16.103 20.3125 15.203 20.3125 14.103V2.10303C20.3125 1.00303 19.4125 0.103027 18.3125 0.103027ZM7.3125 9.10303H5.3125V7.10303H7.3125V9.10303ZM11.3125 9.10303H9.3125V7.10303H11.3125V9.10303ZM15.3125 9.10303H13.3125V7.10303H15.3125V9.10303Z",
          fill: "current",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }